import _ from 'lodash'
import { MutationTree } from 'vuex';
import { VacationApplication, VacationApplicationsState } from '@/store/applications/vacations/types';

const mutations: MutationTree<VacationApplicationsState> = {
  gotVacationApplication: (
    state,
    vacation: VacationApplication,
  ) => {
    state.applications = _.uniqBy([
      vacation,
      ...state.applications,
    ], 'applicationId')
  },
};

export default mutations
